var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolicy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66675 5.83333H13.3334",
    stroke: "#00424B",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66675 9.16667H10.0001",
    stroke: "#00424B",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 17.9167V17.5C10.8333 15.143 10.8333 13.9645 11.5655 13.2323C12.2978 12.5 13.4763 12.5 15.8333 12.5H16.2499M16.6666 11.1193V8.33333C16.6666 5.19063 16.6666 3.61929 15.6903 2.64298C14.714 1.66667 13.1426 1.66667 9.99992 1.66667C6.85723 1.66667 5.28588 1.66667 4.30956 2.64298C3.33325 3.61928 3.33325 5.19063 3.33325 8.33333V12.1202C3.33325 14.8243 3.33325 16.1764 4.07164 17.0923C4.22082 17.2773 4.38934 17.4458 4.57436 17.5949C5.49018 18.3333 6.84227 18.3333 9.54642 18.3333C10.1344 18.3333 10.4283 18.3333 10.6976 18.2383C10.7536 18.2186 10.8084 18.1958 10.862 18.1703C11.1196 18.047 11.3274 17.8392 11.7432 17.4234L15.6903 13.4763C16.172 12.9946 16.4128 12.7538 16.5398 12.4474C16.6666 12.1412 16.6666 11.8005 16.6666 11.1193Z",
    stroke: "#00424B",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicy);
export default __webpack_public_path__ + "static/media/Policy.8641d6d052463e0ca858e562d115e628.svg";
export { ForwardRef as ReactComponent };